<div *ngIf="showMatchbar" class="obs-matchbar-4v4-wrapper" (mousemove)="onMouseMoveHoverFix(hoverObject)"
    #hoverObject>
    <ng-template #resourcesTemplate let-player="player">
        <div class="player-resources" [class.player-resources-full]="showFullResources()">
            <div class="resource resource-gold">{{ getPlayerResources(player)[EResource.GOLD] | number:'1.0-0' }}</div>
            <div class="resource resource-lumber" *ngIf="showFullResources()">{{ getPlayerResources(player)[EResource.LUMBER] | number:'1.0-0' }}</div>
            <div class="resource resource-food"
                [class.no-upkeep-color]="getPlayerResources(player)[EResource.SUPPLY] <= 50"
                [class.low-upkeep-color]="getPlayerResources(player)[EResource.SUPPLY] > 50 && getPlayerResources(player)[EResource.SUPPLY] <= 80"
                [class.high-upkeep-color]="getPlayerResources(player)[EResource.SUPPLY] > 80">
                {{ getPlayerResources(player)[EResource.SUPPLY] | number:'1.0-0' }} / {{ getPlayerResources(player)[EResource.SUPPLY_CAP] | number:'1.0-0' }}
            </div>
        </div>
    </ng-template>

    <div class="match-box match-box-team team-left {{additionalCSS}}">
        <div class="match-box-content">
            <div class="teams">
                <div *ngIf="teams && teams[0]" class="team">
                    <div *ngFor="let player of teams[0]; let playerIndex = index"
                        class="player player-{{playerIndex}} {{player.mainAccount ? 'player-has-alias' : 'player-has-no-alias'}}"
                        [style.color]="getColorCode(player)">
                        <div [class]="'player-color ' + (misc.teamColors ? 'team-colors' : '')"
                            [style.color]="getColorCode(player)">
                            <div class="player-color-2"></div>
                        </div>
                        <div class="player-race" attr.data-race="{{raceNames.get(player.race).toLowerCase()}}"
                            [style.borderColor]="getColorCode(player)"></div>
                        <div class="player-details">
                            <div class="player-name" [style.borderColor]="getColorCode(player)">
                                {{player.mainAccount ? player.mainAccount.name : player.name}}
                            </div>
                            <div class="player-country"
                                *ngIf="player.mainAccount && player.mainAccount.country && player.mainAccount.country != 'tw'"
                                [style.backgroundImage]="'url(/assets/img/flags/'+ player.mainAccount.country +'.png)'">
                            </div>
                        </div>
                        <ng-template [ngTemplateOutlet]="resourcesTemplate"
                            [ngTemplateOutletContext]="{ player: player }"></ng-template>
                        <div class="player-heroes" *ngIf="getPlayerHeroes(player).length > 0">
                            <div class="hero-chip" *ngFor="let hero of getPlayerHeroes(player)">
                                <div class="hero-chip-icon"
                                    [class.grayscaled-filter]="hero.hitpoints && hero.hitpoints.current <= 0"
                                    [style.backgroundImage]="'url(' + getHeroIconPath(hero) + ')'">
                                    <div class="hero-chip-level">{{getHeroLevel(hero)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="match-box match-box-team team-right {{additionalCSS}}">
        <div class="match-box-content">
            <div class="teams">
                <div *ngIf="teams && teams[1]" class="team team-reversed">
                    <div *ngFor="let player of teams[1]; let playerIndex = index"
                        class="player player-{{playerIndex}} {{player.mainAccount ? 'player-has-alias' : 'player-has-no-alias'}}"
                        [style.color]="getColorCode(player)">
                        <div [class]="'player-color ' + (misc.teamColors ? 'team-colors' : '')"
                            [style.color]="getColorCode(player)">
                            <div class="player-color-2"></div>
                        </div>
                        <div class="player-race" attr.data-race="{{raceNames.get(player.race).toLowerCase()}}"
                            [style.borderColor]="getColorCode(player)"></div>
                        <div class="player-details">
                            <div class="player-name" [style.borderColor]="getColorCode(player)">
                                {{player.mainAccount ? player.mainAccount.name : player.name}}
                            </div>
                            <div class="player-country"
                                *ngIf="player.mainAccount && player.mainAccount.country && player.mainAccount.country != 'tw'"
                                [style.backgroundImage]="'url(/assets/img/flags/'+ player.mainAccount.country +'.png)'">
                            </div>
                        </div>
                        <ng-template [ngTemplateOutlet]="resourcesTemplate"
                            [ngTemplateOutletContext]="{ player: player }"></ng-template>
                        <div class="player-heroes" *ngIf="getPlayerHeroes(player).length > 0">
                            <div class="hero-chip" *ngFor="let hero of getPlayerHeroes(player)">
                                <div class="hero-chip-icon"
                                    [class.grayscaled-filter]="hero.hitpoints && hero.hitpoints.current <= 0"
                                    [style.backgroundImage]="'url(' + getHeroIconPath(hero) + ')'">
                                    <div class="hero-chip-level">{{getHeroLevel(hero)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
